import { Separator } from '@commenda/kakashi';
import React from 'react';
import { OnboardingItem } from './OnboardingItem';
import { OnboardingChecklistItem } from './types';

interface OnboardingChecklistCardProps {
  items: OnboardingChecklistItem[];
  header?: React.ReactNode;
}

export const OnboardingChecklistCard = ({
  items,
  header,
}: OnboardingChecklistCardProps) => (
  <div className="border border-primary flex rounded-xl overflow-clip shadow-sm">
    <div className="flex flex-col flex-1">
      {header}
      <div className="flex flex-col gap-3xl px-3xl py-4xl flex-1">
        {items.map((item, idx) => (
          <React.Fragment key={item.heading}>
            <OnboardingItem idx={idx} {...item} />
            {idx !== items.length - 1 && <Separator />}
          </React.Fragment>
        ))}
      </div>
    </div>
    <div className="w-[250px] overflow-hidden shrink-0">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/onboarding/onboarding_hero.png"
        className="object-cover w-full h-full bg-center scale-[2.5] translate-y-[-60%]"
        alt="Onboarding"
      />
    </div>
  </div>
);
